// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface UnderlineIconSignature {
  Element: SVGSVGElement;
}

export const UnderlineIcon: TOC<UnderlineIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14 4V2H20V4H18V12C18 15.309 15.309 18 12 18C8.691 18 6 15.309 6 12V4H4V2H10V4H8V12C8 14.206 9.794 16 12 16C14.206 16 16 14.206 16 12V4H14ZM20 22V20H4V22H20Z"/>
</svg>
</template>;